<ng-template #eventData let-selections="selections">
  <div class="event-data">
    <div class="header-title">{{ selections.title }}</div>
    <div class="dates-labels">
      <div class="dates">{{ selections.dates }}</div>
      <div class="labels" *ngIf="!!selections.labels?.length">
        <ng-container *ngFor="let labelId of selections.labels">
          <label-item *ngIf="accountLabels[labelId] as l" [color]="l.color" [label]="l.label"></label-item>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<home-wrapper [homeTab]="'PUBLISH'" [viewMode]="'table'"  >
  <loader-pane-fragment [trace]="traceNames.viewEventLists"></loader-pane-fragment>
  <ng-container *ngIf="!selectedEventListInfo">
    <command-menu *ngIf="!selectedEventListInfo"
      [filterPage]="filterPage"
      [forceShowAddItem]="true"
      [addItemText]="'+ CREATE A LIST'"
      (addItem)="addEventList()"
    ></command-menu>
    <nested-table
      *ngIf="!selectedEventListInfo"
      [filtersId]="filterPage"
      [items]="eventListsRows"
      [columns]="columnData"
      [columnsById]="columnsById"
      [bigSecondColumn]="true"
      [menuItems]="menuItems"
      [defaultSelectedColumnId]="defaultColumnId"
      [dotMenuItems]="dotMenuItems"
      [showEmptyDiv]="!eventListsRows?.length && loadedTableDataOnce"
      (selectItem)="openEventListFromTable($event)"
      (updatedSelectedIds)="selectIds($event)"
    > <div *ngIf="!eventListsRows?.length" class="empty-table">
        <div class="text-wrapper" *ngIf="!rowsBeforeFiltering">
          <h3>Publish a list of events</h3>
          Here you can publish a list of events to a shareable URL, embed code or JSON. You can even create multiple lists filtering different events for different audiences!
          <div class="grey-text">Note: The event list is populated from published pages in your events. If you do not see an event, make sure it contains a published page.</div>
        </div>
        <div class="text-wrapper" *ngIf="!!rowsBeforeFiltering">
          <h3>No results</h3>
          There are no event lists that match your search query.
        </div>
      </div>
    </nested-table>
  </ng-container>
  <black-bar-wrapper
    *ngIf="selectedEventListInfo as info"
    (close)="closeEventList()"
  ><div class="header">{{ info.title }}</div>
    <joi-nav-wrapper [menuItems]="viewModes" [selectedId]="selectedViewMode" (selectItem)="changeViewMode($event)">
      <!--<small-button [disabled]="publishing || !!publishesLoading" (click)="publishOrUpdateEventList()">{{ publishing ? 'publishing...' : !!publishesLoading ? publishesLoading + ' loading...' : info.status === 'published' ? 'UPDATE' : 'PUBLISH' }}</small-button>-->
      <traffic-light class="status-light" [color]="statusToColor[info.status]" [text]="statusToText[info.status]"></traffic-light>
      <div class="unpublish-link" *ngIf="info.status === 'published'" (click)="unpublishSelectedEventList()">Unpublish</div>
    </joi-nav-wrapper>
    
    <ng-container *ngIf="selectedViewMode === 'SELECT' || !selectedViewMode">
      <div class="above-fold">
        <div class="description">
          <p>Below is a list of the active events in the <b>{{ accounts[accountId].title }}</b> account. Expand each event and select which published pages you would like to include in this event list.</p>
          <p>Note: You cannot include an event that doesn’t have a published page. <span class="link" (click)="helpers.openInNewTab(learnMoreLink)">Learn more<icon [icon]="'OPEN_IN_NEW12'" i12=true></icon></span></p>
          <div class="button-bar">
            <div style="flex:1;"></div>
            <sort-select [sortOption]="info.sortOption" [showLabel]="true" (selectSortOption)="saveSorting($event)" ></sort-select>
            <icon-text [text]="'Name & description'" [icon]="'edit'" (click)="editEventListDetails()"></icon-text>
            <icon-text id="event-filters" [active]="!!selectedEventLabels.size" [text]="'Filter events'" (click)="filterEvents()"></icon-text>
            <icon-text [text]="!allEventSelectionsOpen ? 'Expand all' : 'Collapse all'" [icon]="null"  (click)="expandOrCollapseAll()"></icon-text>
          </div>
        </div>
        <br/>
      </div>
      <div class="below-fold">
        <ng-container *ngFor="let selections of (eventListSelections || []); index as selectionIndex; trackBy: trackBySelections">
          <expanding-wrapper class="event-selections" *ngIf="!filteredOutEventIds.has(selections.eventId) && { open: openEventSelectionsIds.has(selections.eventId) } as vars"
            [expandedState]="vars.open ? 'expand' : 'collapse'"
            [borderGreyOnCollapse]="true"
            [manualToggle]="true"
            (onToggle)="toggleSelection(selections.eventId)"
          >
            <div class="header-left" [ngTemplateOutlet]="eventData" [ngTemplateOutletContext]="{selections: selections}"></div>
            <div class="header-right">
              <div class="right">
                <div class="grey-text" *ngIf="!selections.nInfos">No published pages</div>
                <traffic-light *ngIf="!!selections.nInfos && !!selections.totalSelected" [color]="'green'" [text]="selections.totalSelected + ' selected'"></traffic-light>
                <traffic-light *ngIf="!!selections.nInfos && !selections.totalSelected && vars.open" [color]="'gray'" [text]="'0 selected'"></traffic-light>
                <div class="select-button" *ngIf="!!selections.nInfos && !selections.totalSelected && !vars.open">Select</div>
              </div>
            </div>
            <div [ngClass]="{ hidden: !vars.open }" class="grey-text no-pages" *ngIf="!selections.nInfos">There are no published pages to include</div>
            <div [ngClass]="{ hidden: !vars.open }" class="pages" *ngIf="!!selections.nInfos">
              Select which published pages you would like to include:
              <div class="instance-holder" *ngFor="let instance of selections.instances; index as instanceIndex; trackBy: trackByIndex; last as lastInstance">
                <div class="instance-divider" *ngIf="!!instanceIndex">
                  <ng-container [ngTemplateOutlet]="eventData" [ngTemplateOutletContext]="{selections: selections}"></ng-container>
                  <div style="flex:1;"></div>
                  <icon-text [text]="'Remove instance'" [icon]="'delete24'" (click)="removeInstance(selections, selectionIndex, instanceIndex)"></icon-text>
                </div>
                <ng-container *ngFor="let publishInfo of selections.publishInfos;">
                  <title-toggle-wrapper 
                    *ngIf="{ toggled: instance.publishIds.includes(publishInfo.publishCode) } as vars"
                    [title]="publishInfo.title"
                    [highlighted]="vars.toggled"
                    [hideBottom]="true"
                    [toggleStates]="publishToggleStates"
                    [toggleOn]="vars.toggled"
                    (toggle)="togglePublishInfo(selections, instanceIndex, publishInfo.publishCode)"
                  ></title-toggle-wrapper>
                </ng-container>     
                <div class="add-instance" *ngIf="!!lastInstance">
                  <div class="add_btn" [ngClass]="{ disabled: selections.nInfos === 1 }" (click)="selections.nInfos > 1 ? addInstance(selections, selectionIndex, instanceIndex) : null">+ ADD INSTANCE</div>
                  <menu-hover-button [noWrap]="false" [iconSelector]="'info24'" [width]="'565px'" [customTransform]="'translateX(-100px)'" [noBackground]="true" [hoverText]="addInstanceHint"></menu-hover-button>
                </div>           
              </div>
            </div>
          </expanding-wrapper>
        </ng-container>
      </div>
    </ng-container>

    <event-list-builder *ngIf="selectedViewMode === 'DESIGN'" 
      [eventListInfo]="info" 
      [accountId]="accountId"
      [eventListsFullData]="eventListsFullData"
      [upcomingAndPastEventLists]="upcomingAndPastEventLists"
      [publishesLoading]="publishesLoading"
    ></event-list-builder>

    <ng-container *ngIf="selectedViewMode === 'CONFIGURE'">
      <div class="above-fold">
        <div class="preview-text">
          <p>Use Display Options to configure the information showing on this page</p>
          <div style="flex:1;"></div>
          <icon-text [text]="'Name & description'" [icon]="'edit'" (click)="editEventListDetails()"></icon-text>
          <icon-text [text]="'Display options'" [icon]="null"  (click)="editDisplayOptions()"></icon-text>
        </div>
        <br/>
      </div>
      <div class="below-fold">
        <event-list class="configure"
          [fullData]="eventListsFullData"
          [configureMode]="true"
          [eventLists]="upcomingAndPastEventLists"
          [listInfo]="selectedEventListInfo"
          [loading]="!!publishesLoading"
          [brandingData]="brandingData"
          (editEventThumbnail)="editEventThumbnail($event)"
          (change)="changeBrandingOption($event)"
        >
          <branding-text class="header-text"
            [title]="'Header copy'"
            [brandingText]="selectedEventListInfo.homePageData.headerText"
            (changed)="saveEventListInfo()"
          ></branding-text>
          <branding-text class="footer-text"
            [title]="'Text block'"
            [brandingText]="selectedEventListInfo.homePageData.textBlock"
            (changed)="saveEventListInfo()"
          ></branding-text>
          <branding-block class="slider-block"
            *ngIf="{ count: info.homePageData?.sliderImages?.length || 0 } as s"
            [title]="'Slider Images'"
            [icon]="'scenic'"
            [hideGreyText]="true"
            [greyText]="!s.count ? 'NO SLIDER IMAGES ADDED' : (s.count + ' SLIDER IMAGE' + ( s.count > 0 ? 's' : '') + ' ADDED')"
            [changeText]="'+ ADD SLIDER IMAGE'"
            (change)="editSliderImage(null)"
          ><div class="slider-images-holder">
            <div class="slider-image" *ngFor="let image of (selectedEventListInfo?.homePageData?.sliderImages || []); index as i;">
              <slider-image [sliderImage]="image"></slider-image>
              <div class="image-hover" (click)="editSliderImage(i)">
                <icon [icon]="'camera'"></icon>
              </div>
            </div>
            </div>
          </branding-block>
        </event-list>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedViewMode === 'PREVIEW'">
      <div class="above-fold">
        <div class="preview-text">
          <p>Below is a preview of your webpage</p>
          <div style="flex:1;"></div>
          <button mat-button color="primary" [disabled]="publishing || !!publishesLoading" (click)="publishOrUpdateEventList()">{{ publishing ? 'publishing...' : !!publishesLoading ? publishesLoading + ' loading...' : info.status === 'published' ? 'UPDATE' : 'PUBLISH' }}</button>
        </div>
        <br/>
      </div>
      <div class="below-fold">
        <event-list
          [fullData]="eventListsFullData"
          [eventLists]="upcomingAndPastEventLists"
          [listInfo]="selectedEventListInfo"
          [loading]="!!publishesLoading"
          [brandingData]="brandingData"
        ></event-list>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedViewMode === 'PUBLISHED'">
      <div class="above-fold" *ngIf="info.status !== 'never published'">
        <share-code 
          [shareCode]="info.publishCode"
          [shareType]="shareTypes.events"
          [showEmbed]="true"
          [openText]="'Open in a new tab'"
          [disabled]="info.status !== 'published'"
        ></share-code>
        <div class="publish-info-holder">
          <div class="publish-success" *ngIf="showSuccess">Success!</div>
          <div class="publish-info">
            {{ info.status === 'published' ? 'Last updated' : 'Unpublished' }} by {{ info.publisher }} at {{ info.publishedAt | date: 'h:mmaaaaa\'m\' on d MMMM yyyy' }}.
          </div>
          {{ info.status === 'published' ? 'Below is what’s currently published to your shareable webpage.' : 'Your event list is not published.' }}
        </div>
        <br/>
      </div>
      <div class="below-fold">
        <div *ngIf="selectedEventListInfo.status !== 'published'" class="not-published-notice">
          <div class="title">Nothing here!</div>
          <div class="content">{{ selectedEventListInfo.status === 'never published' ? 'Looks like you haven’t published anything yet. Head back over to the Preview tab to publish your event list.' : 'Your event list is not published.  Head back over to the Preview tab to re-publish your event list or the Select tab to modify it first.' }}</div>
        </div>
        <div *ngIf="publishLoading" class="not-published-notice">
          <div class="title">Event list loading...</div>
        </div>
        <event-list
          *ngIf="!publishLoading && !!publishedData"
          [fullData]="publishedData"
          [eventLists]="upcomingAndPastPublishedEventLists"
          [listInfo]="publishedData.info"
          [loading]="!!publishesLoading"
          [brandingData]="publishedData.brandingData"
        ></event-list>
      </div>
    </ng-container>


  </black-bar-wrapper>
</home-wrapper>